import React, { useEffect, useState } from 'react';
import {
  Box,
  Flex,
  Text,
  IconButton,
  FormControl,
  FormLabel,
  Input,
  Button,
  SimpleGrid,
  useDisclosure,
  VStack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Spinner,
  Center,
  Heading,
  Select,
} from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import AdminSidebar from './AdminSidebar';
import { apiUrl } from '../ApiUrl/ApiUrl';
import { FiEdit, FiTrash2 } from 'react-icons/fi';

function AdminClothes() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [imageFile, setImageFile] = useState(null);
  const [categoriess, setCategoriess] = useState([]);
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [editingBook, setEditingBook] = useState(null);
  // const booksPerPage = 5;
  const [booksPerPage, setBooksPerPage] = useState(10); // Default rows per page
  const [subcategoriesname, setSubcategoriesname] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const personName =localStorage.getItem("loginsetName");
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!category) {
      alert("Please select a main category.");
      return;
    }
    if (!subCategory) {
      alert("Please select a sub-category.");
      return;
    }

  
    const formData = new FormData(e.target);
  
    if (imageFile) {
      formData.append('image', imageFile);
    }
    if (personName) {
      formData.append('person', personName); // ✅ already in use

    }
    try {
      const url = editingBook ? `${apiUrl}/public/updateBookById` : `${apiUrl}/public/savebook`;
      const method = editingBook ? 'PUT' : 'POST';
  
      if (editingBook) {
        formData.append('id', editingBook.id); // Include the book ID for updating
      }
  
      const response = await fetch(url, {
        method: method,
        body: formData,
      });
  
      if (response.ok) {
        alert(editingBook ? 'Product updated successfully!' : 'Product added successfully!');
        e.target.reset();
        setImageFile(null);
        setEditingBook(null); // Reset editing state
        // AllBooks(); // Refresh the book list
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message}`);
      }
    } catch (error) {
      console.error('Error adding/updating product:', error);
      alert('Check All required Fields Then Please try again later.');
    }
  };

 useEffect(() => {
  const fetchSubcategories = async () => {
    try {
      const response = await fetch(`${apiUrl}/public/allsubcatname`);
      const data = await response.json(); 
      setSubcategoriesname(data);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  fetchSubcategories();
}, []);
const [selectedGender, setSelectedGender] = useState('');
const [selectedSize, setSelectedSize] = useState('');

useEffect(() => {
  const fetchBooks = async () => {
    setLoading(true);
    try {
      let url = `${apiUrl}/public/allCloths`;

      const params = new URLSearchParams();
      if (selectedCategory) {
        params.append('subcatname', selectedCategory);
      }
      if (selectedGender) {
        params.append('gender', selectedGender);
      }

      if (selectedSize) {
        params.append('size', selectedSize);
      }

      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      setBooks(data.reverse());
    } catch (error) {
      console.error('Error fetching books:', error);
    } finally {
      setLoading(false);
    }
  };

  fetchBooks();
}, [selectedCategory,selectedGender,selectedSize]);


  const handleEdit = (book) => {
    setEditingBook(book); // Set the entire book object for editing
  };
  const handleDelete = (bookId) => {
    
    fetch(`${apiUrl}/public/deleteById?bid=${bookId}`, {
      method: 'DELETE',
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      alert("Deleted Successfully");
      // AllBooks();
      return response.json();
    })
    .catch(error => {
      console.error('There was a problem with the delete request:', error);
    });
  };
  
    const [searchTerm, setSearchTerm] = useState("");
    // Filter books based on search term
  const filteredBooks = books.filter(book =>
    (book.booktitle && book.booktitle.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (book.maincatname && book.maincatname.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (book.subcatname && book.subcatname.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (book.publisher && book.publisher.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (book.year && book.year.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (book.language && book.language.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (book.author && book.author.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (book.isbn && book.isbn.includes(searchTerm)) ||
    (book.id && book.id.toString().includes(searchTerm)) // Ensure ID is checked as a string
  
  );
  
  // Pagination logic
  const indexOfLastBook = currentPage * booksPerPage;
  const indexOfFirstBook = indexOfLastBook - booksPerPage;
  const currentBooks = filteredBooks.slice(indexOfFirstBook, indexOfLastBook);
  const totalPages = Math.ceil(filteredBooks.length / booksPerPage);
  

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  useEffect(() => {
    fetch(`${apiUrl}/public/allCategories`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch categories");
        }
        return response.json();
      })
      .then((data) => setCategories(data))
      .catch((error) => console.error("Error fetching categories:", error));
  }, []);


  const handleMainCategoryChange = (event) => {
    const selectedCategory = event.target.value;
    setCategory(selectedCategory);
    setSubCategory("");
    setSubCategories([]); // Clear subcategories when category changes

    fetch(`${apiUrl}/public/getsubCatByCatName?cname=${selectedCategory}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch subcategories");
        }
        return response.json();
      })
      .then((data) => setSubCategories(data))
      .catch((error) => console.error("Error fetching subcategories:", error));
  };



  useEffect(() => {
    // When editingBook changes, update the selected category
    if (editingBook) {
      setSelectedCategory(editingBook.searchcategory);
    }
  }, [editingBook]);
  
  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };


  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  useEffect(() => {
    // When editingBook changes, set the initial category value
    if (editingBook) {
      setCategory(editingBook.category);  // Set category based on editingBook
    }
  }, [editingBook]);
  






  return (
<>



    <Flex h="100%" bg="gray.100">
      <AdminSidebar />
      <Box flex="1" p={4}>
        <Flex justify="space-between" align="center" bg="white" p={4} mb={4} borderRadius="md" shadow="sm">
          <IconButton icon={<FiMenu />} aria-label="Open menu" display={{ base: 'block', md: 'none' }} onClick={onOpen} />
          <Text fontSize="xl" fontWeight="bold">
            Product Management
          </Text>
        </Flex>

        <Box bg="white" p={6} borderRadius="md" shadow="sm">
          <Text fontSize="lg" fontWeight="bold" mb={4}>
            Add New Product
          </Text>
          
          <form onSubmit={handleFormSubmit} encType="multipart/form-data">
            <SimpleGrid columns={4} spacing={4}>
              <FormControl id="booktitle" isRequired>
                <FormLabel>Product Name</FormLabel>
                <Input type="hidden" placeholder="Enter book id" name="id" defaultValue={editingBook ? editingBook.id : ''}/>
                <Input type="text" placeholder="Enter Product Name" name="booktitle" defaultValue={editingBook ? editingBook.booktitle : ''}/>
              </FormControl>
            
              <FormControl id="description"isRequired >
                <FormLabel>Description</FormLabel>
                <Input type="text" placeholder="Enter description" name="description" defaultValue={editingBook ? editingBook.description : ''}/>
              </FormControl>
              <FormControl id="image" isRequired>
                <FormLabel>Upload Image</FormLabel>
                <Input type="file" name="imageFile" accept="image/*" onChange={(e) => setImageFile(e.target.files[0])}   />
              </FormControl>
              <FormControl id="originalprice" isRequired>
                <FormLabel>Original Price</FormLabel>
                <Input type="number" placeholder="Enter original price" name="originalprice" defaultValue={editingBook ? editingBook.originalprice : ''}/>
              </FormControl>
              <FormControl id="descprice" isRequired>
                <FormLabel>Discounted Price</FormLabel>
                <Input type="number" placeholder="Enter discounted price" name="descprice" defaultValue={editingBook ? editingBook.descprice : ''}/>
              </FormControl>
 
    
              <FormControl id="hsn">
  <FormLabel>HSN Number</FormLabel>
  <Input 
    type="number" 
    placeholder="Enter HSN" 
    name="hsn" 
    value={editingBook ? editingBook.hsn : 6108} 
    readOnly 
  />
</FormControl>

             
             
              <FormControl id="maincatname" isRequired>
        <FormLabel>Select Category</FormLabel>
        <select name="maincatname" value={category} onChange={handleMainCategoryChange}>
          <option value="">Select Category</option>
          <option value="Cloths-Accessories">Cloths-Accessories</option>
        
        </select>
      </FormControl>

      <FormControl id="subcatname" isRequired>
        <FormLabel>Select Sub Category</FormLabel>
        <select name="subcatname" value={subCategory} onChange={(e) => setSubCategory(e.target.value)} isRequired>
          <option value="">Select Sub Category</option>
          {subCategories.length > 0 ? (
            subCategories.map((sub) => (
              <option key={sub.subcatId} value={sub.subcatname}>
                {sub.subcatname}
              </option>
            ))
          ) : (
            <option value="">No subcategories available</option>
          )}
        </select>
      </FormControl>
      <FormControl id="searchcategory" isRequired  hidden>
        <FormLabel>Select Search Category</FormLabel>
        <select name="searchcategory" value={subCategory} onChange={(e) => setSubCategory(e.target.value)}>
          <option value="">Select Search Category</option>
          {subCategories.length > 0 ? (
            subCategories.map((sub) => (
              <option key={sub.subcatId} value={sub.subcatname}>
                {sub.subcatname}
              </option>
            ))
          ) : (
            <option value="">No subcategories available</option>
          )}
        </select>
      </FormControl>
            

      <FormControl id="size" >
      <FormLabel>Select Size</FormLabel>
      <select name="size">
        <option >Select Size</option>
        <option value="S">S</option>
        <option value="M">M</option>
        <option value="L">L</option>
        <option value="XL">XL</option>
        <option value="XXL">XXL</option>
      </select>
    </FormControl>

    {/* Select Color */}
    <FormControl id="color" >
      <FormLabel>Select Color</FormLabel>
      <select name="color">
        <option value="">Select Color</option>
        <option value="Red">Red</option>
        <option value="Blue">Blue</option>
        <option value="Green">Green</option>
        <option value="Black">Black</option>
        <option value="White">White</option>
      </select>
    </FormControl>

    {/* Select Material */}
    <FormControl id="material" >
      <FormLabel>Select Material</FormLabel>
      <select name="material">
        <option value="">Select Material</option>
        <option value="Cotton">Cotton</option>
        <option value="Polyester">Polyester</option>
        <option value="Wool">Wool</option>
        <option value="Silk">Silk</option>
        <option value="Linen">Linen</option>
      </select>
    </FormControl>
    <FormControl id="gender" >
      <FormLabel>Select Gender</FormLabel>
      <select name="gender">
        <option>Select Gender</option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>
      
      </select>
    </FormControl>
            </SimpleGrid>
            <VStack mt={4} align="stretch">
              <Button type="submit" colorScheme="teal" width="full" >
                Add Product
              </Button>
            </VStack>
          </form>
        </Box>
      </Box>

    </Flex>

    <Box p={3}>
      <Heading as="h2" size="lg" mb={4}>Cloths & Accessories List</Heading>
       
              <div className='flex gap-5'>
                <FormControl id="search" className="py-1" >
                  <FormLabel>Search Products</FormLabel>
                  <Input
      
                    type="text"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    width="300px"
                  />
                </FormControl>
                </div>
      {loading ? (
        <Center>
          <Spinner size="sm" />
        </Center>
      ) : (
        <>
          <TableContainer>
          <Flex justify="space-between" mb={4}>
<div className='flex gap-5'>
   <Select
          width="150px"
          value={booksPerPage}
          onChange={(e) => {
            setBooksPerPage(Number(e.target.value));
            setCurrentPage(1); // Reset to first page on change
          }}
        >
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="20">20 per page</option>
          <option value="50">50 per page</option>
        </Select>
      
        <Select
  placeholder="Select Subcategory"
  width="300px"
  mb={4}
  value={selectedCategory}
  onChange={(e) => setSelectedCategory(e.target.value)}
>
  {subcategoriesname.map((subcat) => (
    <option key={subcat.id} value={subcat.subcatname}>
      {subcat.subcatname} ({subcat.maincatname})
    </option>
  ))}
</Select>
<FormControl id="gender" className="py-1">
 
  <Select
    placeholder="Select Gender"
    width="200px"
    value={selectedGender}
    onChange={(e) => setSelectedGender(e.target.value)}
  >
    <option value="Male">Male</option>
    <option value="Female">Female</option>
 
  </Select>
</FormControl>
<Select
  placeholder="Select Size"
  value={selectedSize}
  onChange={(e) => setSelectedSize(e.target.value)}
>
  <option value="">All Sizes</option>
  <option value="S">S</option>
  <option value="M">M</option>
  <option value="L">L</option>
  <option value="XL">XL</option>
  <option value="XXL">XXL</option>
</Select>



</div>
          <h1>Total Products : {currentBooks.length}</h1>



        {/* <Flex gap={2}>
          <Button onClick={prevPage} isDisabled={currentPage === 1}>
            Previous
          </Button>
          <Button onClick={nextPage} isDisabled={currentPage === totalPages}>
            Next
          </Button>
        </Flex> */}
      </Flex>
            <Table variant="striped" colorScheme="teal">
              <Thead>
                <Tr>
                  <Th>Entry By</Th>
                  <Th>ID</Th>
                  <Th>Title</Th>
            
                  <Th>Original Price</Th>
                  <Th>Descounted Price</Th>
                
                  <Th>Category</Th>
                  <Th>Sub Category</Th>
                  <Th>Search Category</Th>
                 
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <Tbody>
                {currentBooks.map(book => (
                  <Tr key={book.id}>
                    <Td>{book.person ? book.person:'kstar'}</Td>
                    <Td>{book.id}</Td>
                    <Td>{book.booktitle}</Td>
             
                    <Td>{book.originalprice}</Td>
                    <Td>{book.descprice}</Td>
                   
                    <Td>{book.maincatname}</Td>
                    <Td>{book.subcatname}</Td>
                    <Td>{book.searchcategory}</Td>
                   
                   
                    <Td>
                      <Flex gap={2}>
                        <IconButton
                          aria-label="Edit Book"
                          icon={<FiEdit />}
                          // onClick={() => handleEdit(book)}
                          onClick={() => {
                            handleEdit(book);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                          }}
                        />
                        <IconButton
                          aria-label="Delete Book"
                          icon={<FiTrash2 />}
                          colorScheme="red"
                          onClick={() => handleDelete(book.id)}
                        />
                      </Flex>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
          <Flex justify="space-between" mt={4}>
            <Button onClick={handlePreviousPage} disabled={currentPage === 1}>
              Previous
            </Button>
            <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
              Next
            </Button>
          </Flex>
        </>
      )}
    </Box>
</>
    
  );
}

export default AdminClothes;
